/**
 * Plan data structure
 */
export class Plan {
  // ext={bundleCode: 'pro_zvu'}
  constructor(
    planCode,
    name,
    billingCycle,
    category,
    type,
    selectNumber,
    price,
    capacity,
    capacityUnit,
    unit,
    extra = {},
  ) {
    this.planCode = planCode; // Unique identifier
    this.name = name;
    this.billingCycle = billingCycle; // 'monthly', 'yearly', etc.
    this.category = category; // Category, used for rule judgment
    this.capacity = capacity;
    this.capacityUnit = capacityUnit; // Unit type from planUnitMap (attendee or participant)
    this.unit = unit; // Unit type for general plan display (license, user, etc.)
    this.type = type; // Type
    this.selectNumber = selectNumber; // Selected quantity
    this.price = price;
    this.extra = extra;
  }
}
